<template>
  <div class="comment" id="comment">
    <ul class="commentlist">
      <li v-for="item in anArray">
        <div class="uhead" v-if="item.head">
          <img :src="avatarPath + item.head+'@1x.png'">
        </div>
        <div class="uhead" v-else>
          <img :src="defaultAvatar">
        </div>
        <div class="uinfo">
          <div class="top">
            <p class="uname">{{ item.nickname }}</p>
            <p class="time">{{ item.createTime }}</p>
          </div>
          <p class="ucommment" v-if="item.type==='img'"><img
            :src="'https://mai-ydgpzbj.ydtg.com.cn/static/index/img/faces/'+item.question+'@2x.png'"></p>
          <p class="ucommment" v-else>{{ item.question }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import service from "../js/getmsg";

export default {
  name: "Comment",
  data() {
    return {
      avatarPath: 'https://yuanda-live.oss-cn-beijing.aliyuncs.com/zbj/files/avatars/',
      defaultAvatar: 'https://yuanda-live.oss-cn-beijing.aliyuncs.com/zbj/files/avatars/default@1x.png',
      anArray: service.msgArr,
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/zb/components/Comment.vue